<template>
  <MultibarChart
    :request-status="requestStatus"
    :series="rawSeries"
    :title="title"
    :item-id="itemId"
    :is-expanded-card="isExpandedCard"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import MultibarChart from '@/components/cards/models/MultibarChart';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'TermMultibarChart',
  components: {
    MultibarChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    isExpandedCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      classifiedPercentage: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringMultibar',
        serviceParams: {
          type: 'terms',
        },
      })
        .then(response => {
          this.rawSeries = response.data;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped>
</style>
